import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  borderRadius,
  borderRadiusSizes,
  colorConstants,
  margin,
  marginSizes,
  padding,
  paddingSizes,
  stateColors,
  states,
  stateThemes
} from '@jarvis.oddle/core/theme/default'
import { P } from '@jarvis.oddle/core/components/Typo'
import Flex from '@jarvis.oddle/core/components/Flex'
import {
  InlineNotification,
  notificationStates
} from '@jarvis.oddle/core/components/InlineNotification'
import Collapsible from '@jarvis.oddle/core/components/Collapsible'
import IconClose from '@jarvis.oddle/core/components/Icons/IconClose'

const TextContainer = styled(InlineNotification).attrs(() => ({
  width: '100%'
}))`
  position: relative;
`

const CloseButtonContainer = styled(Flex)`
  position: absolute;
  top: ${padding[paddingSizes.small]};
  right: ${padding[paddingSizes.small]};
  padding: ${padding[paddingSizes.extraSmall]};
  border-radius: ${borderRadius[borderRadiusSizes.medium]};
  background-color: ${() =>
    stateColors.backgroundColors[states.warning][stateThemes.light]};
  cursor: pointer;
`

export const CloseButton = ({
  onClick,
  className
}: {
  onClick: () => void
  className?: string
}): JSX.Element => (
  <CloseButtonContainer
    data-testid='button.close'
    className={className}
    onClick={onClick}
  >
    <IconClose iconSize='small' fill={colorConstants.black} />
  </CloseButtonContainer>
)
CloseButton.propTypes = {
  onClick: PropTypes.func
}

const NotificationBanner = React.memo(() => {
  const [visible, setVisible] = React.useState(true)

  const onClick = React.useCallback(() => setVisible(false), [])

  return (
    <div
      id='notification-banner-container'
      style={{
        marginTop: visible ? margin[marginSizes.small] : 0,
        marginBottom: visible ? margin[marginSizes.small] : 0,
        display: 'none',
        width: '100%'
      }}
    >
      <Collapsible show={visible}>
        <TextContainer state={notificationStates.warning}>
          <P
            normalised
            id='notification-banner-primary-text'
            marginRight={marginSizes.small}
            color={colorConstants.black}
          />
          <P
            normalised
            id='notification-banner-secondary-text'
            marginRight={marginSizes.small}
            color={colorConstants.black}
          />
          <CloseButton onClick={onClick} />
        </TextContainer>
      </Collapsible>
    </div>
  )
})

export default NotificationBanner
